import { createSelectors } from "@mod/core/utils/create-selectors";
import dayjs from "dayjs";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { Commitment, CommitmentServer, CommitmentStore, CommitmentStoreActions } from "./types";

const initialState: CommitmentStore = {
  commitmentSelected: null,
  serverSelected: null,
  mainTabSelected: "servers",
  searchText: "",
  preventSocketUpdate: false,
  attendanceFilters: {
    pending: false,
    attended: false
  },
  selectedServers: []
};

const useCommitmentStoreBase = create(
  persist<CommitmentStore & CommitmentStoreActions>(
    (set, get) => ({
      ...initialState,
      selectCommitment: (commitment: Commitment | null) => {
        set(() => ({
          commitmentSelected: commitment || null
        }));
      },
      selectMainTab: (tab: CommitmentStore["mainTabSelected"]) => {
        set(() => ({
          mainTabSelected: tab
        }));
      },
      selectServer: (server: CommitmentServer | null) => {
        set(() => ({
          serverSelected: server || null
        }));
      },
      setSearchText: (text: string) => {
        set(() => ({
          searchText: text
        }));
      },
      setPreventSocketUpdate: (value: boolean) => {
        set(() => ({
          preventSocketUpdate: value
        }));
      },
      isCommitmentInProgress: () =>
        !!get().commitmentSelected &&
        !dayjs().isBefore(dayjs(get().commitmentSelected?.startDate, "YYYY-MM-DD"), "day"),
      isCommitmentDone: () =>
        !!get().commitmentSelected && dayjs().isAfter(dayjs(get().commitmentSelected?.endDate, "YYYY-MM-DD"), "day"),
      setAttendanceFilters: (filters: CommitmentStore["attendanceFilters"]) => {
        set(() => ({
          attendanceFilters: filters
        }));
      },
      setSelectedServers: (servers: CommitmentServer[]) => {
        set(() => ({
          selectedServers: servers
        }));
      }
    }),
    {
      name: "commitment-store",
      storage: createJSONStorage(() => sessionStorage) // (optional) by default, 'localStorage' is used
    }
  )
);

export const useCommitmentStore = createSelectors(useCommitmentStoreBase);
